import {api} from "./api";

export const shortUrlApi = {
  createShortUrl: async (url) => {
    return await api.classRequestSvcRequest('POST', '/shortUrls', {url});
  }
}